import axios from 'axios';
import { all, put, select, takeLatest } from 'redux-saga/effects';

import { COMPANIES } from 'app/api-routes';
import {
  settingsRequest,
  settingsSuccess,
  settingsFailure,
  updateSettingsRequest,
  updateSettingsSuccess,
  updateSettingsFailure,
} from './actions';

const selectCompanyID = (state) => state.auth?.companyInfo?.companyID;

function* settingsSaga() {
  try {
    const companyID = yield select(selectCompanyID);
    if (companyID == null) {
      yield put(settingsFailure(new Error('companyID missing')));
      return;
    }
    const { payload, warnings } = yield axios.get(
      `${COMPANIES}/${companyID}/chat-settings`
    );
    yield put(settingsSuccess(payload, { warnings }));
  } catch (err) {
    yield put(settingsFailure(err));
  }
}

function* updateSettingsSaga({ payload }) {
  try {
    const companyID = yield select(selectCompanyID);
    if (companyID == null) {
      yield put(updateSettingsFailure(new Error('companyID missing')));
      return;
    }
    const { warnings } = yield axios.put(
      `${COMPANIES}/${companyID}/chat-settings`,
      { payload }
    );
    yield put(updateSettingsSuccess(payload, { warnings }));
    yield put(settingsRequest());
  } catch (err) {
    yield put(updateSettingsFailure(err));
  }
}

export default function* () {
  yield all([
    takeLatest(settingsRequest, settingsSaga),
    takeLatest(updateSettingsRequest, updateSettingsSaga),
  ]);
}
